import { render } from "./SocialProfile.vue?vue&type=template&id=48a6a62b&scoped=true"
import script from "./SocialProfile.vue?vue&type=script&lang=js"
export * from "./SocialProfile.vue?vue&type=script&lang=js"

import "./SocialProfile.vue?vue&type=style&index=0&id=48a6a62b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48a6a62b"]])

export default __exports__